import React from 'react';
import useRequestPriorities from '../../../queries/useRequestPriorities';

const PriorityList = React.forwardRef(({ render, ...props }, ref) => {
  const { data, isFetching } = useRequestPriorities({ staleTime: Infinity });
  return render({ priorities: data, loading: isFetching, ref, props });
});

export default PriorityList;
